// extracted by mini-css-extract-plugin
module.exports = {"nameField":"TableItem_nameField__1gsGo"};